/**
 * The GraphQL object types that all expose the same booking task result row: the
 * list query's `ParticipantBookingTaskResult`, the generic `BookingTaskResult`
 * that `createBookingTaskResults` returns, and the `BookingTaskResult<Block>`
 * each per-block update mutation returns.
 *
 * graphcache keys entities as `Typename:_id`, so by default each of these is a
 * separate cache entity and a status write never reaches the copy the list is
 * linked to. `_id` is a Mongo ObjectID and identifies the row under every one of
 * them, so listing them here keys them on `_id` alone and collapses them onto a
 * single entity.
 *
 * The merged entity's stored `__typename` is whichever type wrote last, so a
 * cached read can report a node as `BookingTaskResultOpenAnswer` where the schema
 * says `ParticipantBookingTaskResult`. A result's own `__typename` is therefore
 * not a reliable discriminator for the row — `details.type` is.
 */
export const taskResultGlobalIds = [
  'BookingTaskResult',
  'BookingTaskResultCardSort',
  'BookingTaskResultFigmaPrototype',
  'BookingTaskResultLiveMobileTest',
  'BookingTaskResultLiveWebsiteTest',
  'BookingTaskResultMatrix',
  'BookingTaskResultMultipleChoiceQuestion',
  'BookingTaskResultOpenAnswer',
  'BookingTaskResultOpinionScale',
  'BookingTaskResultStackRank',
  'BookingTaskResultSystemUsabilityScale',
  'BookingTaskResultTreeTest',
  'ParticipantBookingTaskResult',
];
